<div class="modal-header">
  <h5 class="modal-title">Warning</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss();"></button>
</div>

<div class="modal-body">
  <div class="fw-semibold mb-2">The following projects have already been cloned:</div>

  <ul class="mb-3" *ngIf="projects?.length; else noneTpl">
    <li *ngFor="let p of projects">
      {{ p.projectName }} <span class="text-muted">— {{ p.clientName }}</span>
    </li>
  </ul>

  <ng-template #noneTpl>
    <div class="text-muted">No projects found.</div>
  </ng-template>

  <div class="mt-2">Would you still like to proceed?</div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss();">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="confirm();">Confirm</button>
</div>